import { render, staticRenderFns } from "./NewToDos.vue?vue&type=template&id=7b15c629&scoped=true"
import script from "./NewToDos.vue?vue&type=script&lang=js"
export * from "./NewToDos.vue?vue&type=script&lang=js"
import style0 from "./NewToDos.vue?vue&type=style&index=0&id=7b15c629&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b15c629",
  null
  
)

export default component.exports